import en from '../languages/en.json';
import sv from '../languages/sv.json';

export const translations = {
  en,
  sv,
};
